module.exports = __webpack_public_path__ + "img/xiaofeng-img2.4406b3c0.png";